import { Table, TD, TR } from '@ag-media/react-pdf-table';
import { View } from '@react-pdf/renderer';
import { formatISO } from 'date-fns';
import { PatientInfoState } from 'features/patient/_utils/patient-info/patient-info-slice-types';
import { TableText } from './pdf-default-components';

export function ReportOverview(props: { patientInfo: PatientInfoState }) {
  const currentDate = formatISO(new Date(), { representation: 'date' });
  const lastAssessmentDate = formatISO(
    props.patientInfo.concussion!.evaluatedOn.toDate(),
    { representation: 'date' }
  );

  const config = [
    {
      key: 'Date of report',
      value: currentDate
    },
    {
      key: 'Test-Taker Name',
      value: props.patientInfo.patient.displayName
    },
    /**
     * This is disabled until we create an API to get the list of assigned Clinicians from a Test-Taker ID
     */
    // {
    //   key: "",
    //   value: ""
    // },
    {
      key: 'Date of last assessment',
      value: lastAssessmentDate
    }
  ];

  return (
    <View>
      <Table
        style={{
          fontFamily: 'Comfortaa',
          borderWidth: 0.1
        }}
        tdStyle={{
          padding: 2,
          borderWidth: 0.3
        }}
        // The first column has a column-width (weight) of 25% of the table width
        weightings={[0.25]}
      >
        {config.map((item, i) => (
          <TR key={i}>
            <TD>
              <TableText>{item.key}</TableText>
            </TD>
            <TD>
              <TableText>{item.value}</TableText>
            </TD>
          </TR>
        ))}
      </Table>
    </View>
  );
}
